export { DMS_MODULE } from '../constants';
export const NAME = 'WmsVasSupervisor';
export const API_NAME = 'WmsVasSupervisor';
export const CRUMB_LABEL_KEY = 'WmsVasSupervisor';
